import { useNavigate, useLocation } from "react-router-dom";
import { useRef, useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import LangDropdown from "./LangDropdown";

function NavbarStaff() {
  const navigate = useNavigate();
  const location = useLocation();
  const [roomOpen, setRoomOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropRef = useRef(null);
  const { lang } = useLanguage();

  const isActive = (path) => location.pathname === path;

  // ปิดเมนูมือถือเมื่อเปลี่ยนหน้า
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const go = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const isRoomGroup = [
    "/calendar",
    "/booking",
    "/cancellations",
    "/checkin",
    "/checkout",
    "/slips", // ✅ เพิ่ม
  ].includes(location.pathname);

  useEffect(() => {
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target))
        setRoomOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const roomItems = [
    { labelKey: "roomBooking", path: "/booking",       icon: iconBed() },
    { labelKey: "roomDetail",  path: "/calendar",      icon: iconList() },
    { labelKey: "cancelReq",   path: "/cancellations", icon: iconBan() },
    { labelKey: "checkIn",     path: "/checkin",       icon: iconIn() },
    { labelKey: "checkOut",    path: "/checkout",      icon: iconOut() },
    { labelKey: "verifySlip",  path: "/slips",         icon: iconSlip() },
  ];

  return (
    <>
      <style>{`
        .snav {
          background: #fff;
          box-shadow: 0 2px 8px rgba(0,0,0,.08);
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 60px;
          position: sticky;
          top: 0;
          z-index: 1000;
          font-family: 'Noto Sans Thai', sans-serif;
          font-size: 13.5px;
        }
        .snav-brand {
          display: flex; align-items: center; gap: 10px; cursor: pointer;
        }
        .snav-logo {
          width: 40px; height: 40px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .snav-logo img { width: 100%; height: 100%; object-fit: contain; }
        .snav-title {
          font-size: 14px; font-weight: 700; color: #1a1a1a; white-space: nowrap;
        }
        .snav-badge {
          display: inline-block;
          background: #0d9488; color: #fff;
          font-size: 10px; font-weight: 700;
          padding: 1px 7px; border-radius: 99px;
          margin-left: 6px; vertical-align: middle;
          letter-spacing: .5px;
        }
        .snav-actions { display: flex; align-items: center; gap: 6px; }
        .snav-right { display: flex; align-items: center; gap: 2px; }
        .snav-btn {
          display: flex; align-items: center; gap: 5px;
          padding: 5px 10px; border-radius: 7px;
          font-size: 13px; font-weight: 500; color: #374151;
          background: none; border: none; cursor: pointer;
          white-space: nowrap; transition: background .15s, color .15s;
          font-family: 'Noto Sans Thai', sans-serif;
        }
        .snav-btn:hover { background: #f3f4f6; color: #111; }
        .snav-btn.active { background: #f0fdfa; color: #0f766e; }
        .snav-btn.room-active { background: #f0fdfa; color: #0f766e; }
        .snav-dropdown-wrap { position: relative; }
        .snav-dropdown {
          position: absolute; top: calc(100% + 6px); left: 0;
          background: #fff; border: 1px solid #e5e7eb;
          border-radius: 10px; box-shadow: 0 8px 24px rgba(0,0,0,.10);
          min-width: 170px; padding: 4px 0; z-index: 999;
        }
        .snav-drop-item {
          display: flex; align-items: center; gap: 8px;
          padding: 9px 14px;
          font-size: 13px; font-weight: 500; color: #374151;
          background: none; border: none; cursor: pointer;
          width: 100%; text-align: left; white-space: nowrap;
          transition: background .12s, color .12s;
          font-family: 'Noto Sans Thai', sans-serif;
        }
        .snav-drop-item:hover { background: #f3f4f6; color: #111; }
        .snav-drop-item.active { background: #f0fdfa; color: #0f766e; }
        .snav-drop-item.cancel-item:hover { background: #fff1f1; color: #991b1b; }
        .snav-drop-item.cancel-item.active { background: #fee2e2; color: #991b1b; }
        .snav-drop-item.slip-item:hover { background: #f0fdf4; color: #065f46; }
        .snav-drop-item.slip-item.active { background: #dcfce7; color: #065f46; }
        .snav-drop-divider { height: 1px; background: #f3f4f6; margin: 4px 0; }
        .snav-logout {
          display: flex; align-items: center; gap: 5px;
          padding: 5px 10px; border-radius: 7px;
          font-size: 13px; font-weight: 600; color: #dc2626;
          background: none; border: none; cursor: pointer;
          white-space: nowrap; transition: background .15s;
          font-family: 'Noto Sans Thai', sans-serif;
        }
        .snav-logout:hover { background: #fff1f1; }
        .snav-status-dot {
          width: 7px; height: 7px; border-radius: 50%;
          background: #22c55e; display: inline-block; margin-right: 4px;
          animation: snav-pulse 2s infinite;
        }
        @keyframes snav-pulse {
          0%,100% { box-shadow: 0 0 0 0 rgba(34,197,94,.4); }
          50%      { box-shadow: 0 0 0 5px rgba(34,197,94,0); }
        }

        /* ── Hamburger (ซ่อนบนจอใหญ่) ── */
        .snav-hamburger {
          display: none;
          background: none; border: none; cursor: pointer;
          padding: 8px; border-radius: 8px; color: #374151;
        }
        .snav-hamburger:hover { background: #f3f4f6; }

        /* ── Responsive ── */
        @media (max-width: 860px) {
          .snav { padding: 0 14px; }
          .snav-hamburger { display: flex; align-items: center; justify-content: center; }
          .snav-right {
            position: fixed;
            top: 60px; left: 0; right: 0;
            flex-direction: column;
            align-items: stretch;
            gap: 2px;
            background: #fff;
            padding: 8px;
            box-shadow: 0 10px 20px rgba(0,0,0,.12);
            border-top: 1px solid #f1f5f9;
            max-height: calc(100vh - 60px);
            overflow-y: auto;
            transform: translateY(-130%);
            transition: transform .25s ease;
            visibility: hidden;
          }
          .snav-right.open { transform: translateY(0); visibility: visible; }
          .snav-btn, .snav-logout {
            width: 100%;
            justify-content: flex-start;
            padding: 12px 14px;
            font-size: 15px;
            border-radius: 8px;
          }
          .snav-dropdown-wrap { width: 100%; }
          /* ทำให้ dropdown กลายเป็น accordion */
          .snav-dropdown {
            position: static;
            box-shadow: none;
            border: none;
            border-radius: 0;
            min-width: 0;
            padding: 2px 0 2px 16px;
          }
          .snav-drop-item { padding: 11px 14px; font-size: 14px; border-radius: 8px; }
        }
      `}</style>

      <nav className="snav">
        {/* Brand */}
        <div className="snav-brand" onClick={() => navigate("/calendar")}>
          <div className="snav-logo"><img src="/logo-mark.png" alt="logo" /></div>
          <span className="snav-title">
            Eurngkam
            <span className="snav-badge">Staff</span>
          </span>
        </div>

        {/* Actions zone: เมนู (drawer) + ภาษา + avatar + hamburger */}
        <div className="snav-actions">

        {/* Right */}
        <div className={`snav-right ${menuOpen ? "open" : ""}`}>

          {/* สถานะ */}
          <button
            className={`snav-btn ${isActive("/statuspage") ? "active" : ""}`}
            onClick={() => go("/statuspage")}
          >
            {iconBell()}
            <span className="snav-status-dot" />
            {t(lang, "status")}
          </button>

          {/* จัดการห้อง dropdown */}
          <div className="snav-dropdown-wrap" ref={dropRef}>
            <button
              className={`snav-btn ${isRoomGroup ? "room-active" : ""}`}
              onClick={() => setRoomOpen((p) => !p)}
            >
              {iconGrid()} {t(lang, "manageRooms")}
              <svg
                width="11" height="11" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                style={{ transition: "transform .2s", transform: roomOpen ? "rotate(180deg)" : "none" }}
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>

            {roomOpen && (
              <div className="snav-dropdown">
                {roomItems.map((item, i) => {
                  // divider ก่อน "เช็คอิน" (index 3) และ "ตรวจสลิป" (index 5)
                  const showDivider = i === 3 || i === 5;
                  const extraClass =
                    item.path === "/cancellations" ? "cancel-item" :
                    item.path === "/slips"         ? "slip-item"   : "";
                  return (
                    <span key={item.path}>
                      {showDivider && <div className="snav-drop-divider" />}
                      <button
                        className={`snav-drop-item ${extraClass} ${isActive(item.path) ? "active" : ""}`}
                        onClick={() => { go(item.path); setRoomOpen(false); }}
                      >
                        {item.icon} {t(lang, item.labelKey)}
                      </button>
                    </span>
                  );
                })}
              </div>
            )}
          </div>

          {/* โปรไฟล์ */}
          <button
            className={`snav-btn ${isActive("/profile") ? "active" : ""}`}
            onClick={() => go("/profile")}
          >
            {iconUser()} {t(lang, "profile")}
          </button>

          {/* ภาษา */}
          <LangDropdown />

          {/* Logout */}
          <button className="snav-logout" onClick={handleLogout}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            {t(lang, "logout")}
          </button>
        </div>

        {/* Hamburger (มือถือ) */}
        <button
          className="snav-hamburger"
          onClick={() => setMenuOpen((p) => !p)}
          aria-label="menu"
        >
          {menuOpen ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          )}
        </button>
        </div>
      </nav>
    </>
  );
}

/* ── Icons ── */
function iconGrid() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
}
function iconBed() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/></svg>;
}
function iconList() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
}
function iconBan() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>;
}
function iconIn() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>;
}
function iconOut() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
}
function iconUser() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
}
function iconBell() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
}
function iconSlip() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="12" y2="17"/></svg>;
}

export default NavbarStaff;